var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message_attachment" },
    [
      _vm.attachment.type == "image"
        ? _c("lightbox", {
            attrs: {
              options: { rel: "lightbox[chat-main]" },
              images: [
                {
                  src: _vm.attachment.url,
                  thumb: _vm.attachment.thumburl,
                  rel: "lightbox[chat-main]"
                }
              ],
              id: _vm.msgcreated.toString()
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.attachment.type == "video"
        ? _c(
            "video",
            { attrs: { controls: "", playsinline: "", preload: "metadata" } },
            [
              _c("source", {
                attrs: { src: _vm.attachment.url + "#t=0.1", type: "video/mp4" }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }